/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobSortCriteria {
    getFixupPrototypeFunction() { return BackgroundJobSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobSortCriteria>): BackgroundJobSortCriteria {
        let obj = Object.assign(new BackgroundJobSortCriteria(), model);
        BackgroundJobSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobSortCriteria>): BackgroundJobSortCriteria {
        if (!model) return null;
        return BackgroundJobSortCriteria.newInstance(<BackgroundJobSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobSortCriteria) {
        if (!obj) return;

        models.BackgroundJobSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobSortCriteria): boolean {
        Object.setPrototypeOf(obj, BackgroundJobSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.BackgroundJobSortColumn;

    ascending: boolean;

}
